<template>
  <page-section :content="content.sections.about" />
</template>

<script setup>
import content from "../content.js";
import PageSection from "./../components/section/Section.vue";
</script>
